export const REGEX_CODFIS = /^(?:[0-9A-Z]{16}|[0-9]{11}|[0-9A-Z]{9})$/;
